import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState(""); // "", "sending", "success", "error"

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      const response = await fetch("https://formspree.io/f/xjkgjoaa", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <div>
      {/* ═══════ Hero / Breadcrumb ═══════ */}
      <section className="contact-hero">
        <div className="contact-hero__container">
          <span className="contact-hero__label">Contact</span>
          <h1 className="contact-hero__title">
            <span>Contactez</span>-Nous
          </h1>
          <div className="contact-hero__breadcrumb">
            <Link to="/">Accueil</Link>
            <span>/</span>
            <span>Contact</span>
          </div>
        </div>
      </section>

      {/* ═══════ Info Cards ═══════ */}
      <section className="contact-info">
        <div className="contact-info__container">
          <div className="contact-info__grid">
            <div className="info-card">
              <div className="info-card__icon">📍</div>
              <div className="info-card__content">
                <h4>Notre adresse</h4>
                <p>29 Bis, rue Oum Kalthoum, 1001 Tunis</p>
              </div>
            </div>
            <div className="info-card">
              <div className="info-card__icon">📞</div>
              <div className="info-card__content">
                <h4>Téléphone</h4>
                <p>
                  <a href="tel:+21671330366">+216 71 330 366</a>
                </p>
              </div>
            </div>
            <div className="info-card">
              <div className="info-card__icon">✉️</div>
              <div className="info-card__content">
                <h4>Email</h4>
                <p>
                  <a href="mailto:ste@bouchaddakh.com">ste@bouchaddakh.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════ Contact Form + Details ═══════ */}
      <section className="contact-section">
        <div className="contact-section__container">
          {/* Left: Details */}
          <div className="contact-details">
            <span className="section-label">Société BOUCHADDAKH</span>
            <h2 className="section-title">N'hésitez pas à nous contacter</h2>
            <p className="contact-details__text">
              Nous sommes à votre disposition pour répondre à toutes vos
              questions, vous fournir un devis personnalisé ou vous conseiller
              sur nos produits et services.
            </p>

            <div className="contact-details__items">
              <div className="contact-item">
                <div className="contact-item__icon">🏢</div>
                <div className="contact-item__text">
                  <h5>Siège social</h5>
                  <p>29 Bis, rue Oum Kalthoum, 1001 Tunis</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-item__icon">📞</div>
                <div className="contact-item__text">
                  <h5>Appelez-nous</h5>
                  <p>
                    <a href="tel:+21671330366">+216 71 330 366</a>
                  </p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-item__icon">✉️</div>
                <div className="contact-item__text">
                  <h5>Écrivez-nous</h5>
                  <p>
                    <a href="mailto:ste@bouchaddakh.com">ste@bouchaddakh.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <div className="contact-form-card">
            <h3>Envoyez-nous un message</h3>
            <p>Remplissez le formulaire et nous vous répondrons rapidement.</p>

            <form onSubmit={handleSubmit}>
              <div className="contact-form__row">
                <div className="contact-form__field">
                  <label>Nom</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Votre nom"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="contact-form__field">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="votre@email.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="contact-form__field">
                <label>Sujet</label>
                <input
                  type="text"
                  name="subject"
                  placeholder="Sujet de votre message"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="contact-form__field">
                <label>Message</label>
                <textarea
                  name="message"
                  placeholder="Écrivez votre message ici..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="contact-form__submit">
                {status === "sending" ? "Envoi en cours..." : "Envoyer le message →"}
              </button>

              {status === "success" && (
                <div className="contact-form__status contact-form__status--success">
                  ✅ Message envoyé avec succès ! Nous vous répondrons rapidement.
                </div>
              )}
              {status === "error" && (
                <div className="contact-form__status contact-form__status--error">
                  ❌ Erreur lors de l'envoi. Veuillez réessayer.
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* ═══════ Map ═══════ */}
      <div className="contact-map">
        <iframe
          title="Localisation BOUCHADDAKH"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1394!2d10.1845656!3d36.7970582!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd35fd48b2b29d%3A0x99c666a51da0e66!2ssoci%C3%A9t%C3%A9%20bouchaddakh!5e0!3m2!1sfr!2stn!4v1700000000000"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}

export default Contact;
